import TopTicker from './components/TopTicker';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import FeaturedDigs from './components/FeaturedDigs';
import CollectionIndex from './components/CollectionIndex';
import EventTimeline from './components/EventTimeline';
import UpdateStream from './components/UpdateStream';
import TopicIndex from './components/TopicIndex';
import CommunityTalk from './components/CommunityTalk';
import SubscribeCta from './components/SubscribeCta';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopTicker />
      <Navbar />
      <main className="w-full flex-1">
        <Hero />
        <FeaturedDigs />
        <CollectionIndex />
        <EventTimeline />
        <UpdateStream />
        <TopicIndex />
        <CommunityTalk />
        <SubscribeCta />
      </main>
      <Footer />
    </div>
  );
}